// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx actions / selectors
import { changeSearchTypes } from '../search-all-params/search-all-params.actions';
export const searchTypes = createReducer([], on(changeSearchTypes, (state, action) => {
    return action.searchTypes;
}));
